<div class="page">
  <header class="topbar">
    <div>
      <p class="eyebrow">Painel interno</p>
      <h1>Códigos MFA</h1>
    </div>
    <div style="display: flex; gap: 12px; align-items: center;">
      <a routerLink="/athletes" class="ghost link-button">Atletas</a>
      <button class="ghost" (click)="logout()">Sair</button>
    </div>
  </header>

  <section class="card">
    <form [formGroup]="form" (ngSubmit)="search()">
      <div class="filters">
        <label>
          <span>E-mail</span>
          <input type="text" formControlName="email" placeholder="Buscar por e-mail" />
        </label>
        <label>
          <span>Contexto</span>
          <select formControlName="context">
            <option value="">Todos</option>
            <option value="athlete">Atleta</option>
            <option value="login">Login</option>
          </select>
        </label>
        <label>
          <span>Status</span>
          <select formControlName="verified">
            <option value="">Todos</option>
            <option value="true">Verificado</option>
            <option value="false">Não verificado</option>
          </select>
        </label>
        <label>
          <span>Expiração</span>
          <select formControlName="expired">
            <option value="">Todos</option>
            <option value="true">Expirado</option>
            <option value="false">Válido</option>
          </select>
        </label>
      </div>
      <div class="actions">
        <button type="button" class="ghost" (click)="resetFilters()">Limpar</button>
        <button type="submit" [disabled]="loading">Buscar</button>
      </div>
    </form>
  </section>

  <section class="list card">
    <div *ngIf="loading" class="feedback">Carregando códigos MFA...</div>
    <div *ngIf="errorMessage" class="feedback error">{{ errorMessage }}</div>

    <div class="mfa-code" *ngFor="let code of codes" [class]="getStatusClass(code)">
      <div class="mfa-code__header">
        <div>
          <p class="eyebrow">{{ code.context === 'athlete' ? 'Atleta' : 'Login' }}</p>
          <h3>{{ code.email }}</h3>
        </div>
        <span class="status-badge">
          {{ getStatusText(code) }}
        </span>
      </div>

      <div class="mfa-code__meta">
        <div>
          <small>Código</small>
          <p><code>{{ code.code }}</code></p>
        </div>
        <div>
          <small>Criado em</small>
          <p>{{ formatDate(code.created_at) }}</p>
        </div>
        <div>
          <small>Expira em</small>
          <p>{{ formatDate(code.expires_at) }}</p>
        </div>
        <div>
          <small>Verificado em</small>
          <p>{{ formatDate(code.verified_at) || '—' }}</p>
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !codes.length" class="feedback">Nenhum código MFA encontrado.</div>
  </section>

  <section class="card" *ngIf="pagination && pagination.total > pagination.per_page">
    <div class="pagination">
      <p>
        Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} códigos
      </p>
    </div>
  </section>
</div>

